module.exports = __webpack_public_path__ + "static/media/tiktok-top-icons-en.86bab058.svg";